import { flowChart } from "#root/dashboard/charts/components/flow_chart";
export function flowChartBox(chart) {
  const chartHolder = document.createElement("div");
  chartHolder.classList.add("chart-holder");
  chartHolder.style.overflowX = "auto";
  const chartViewport = document.createElement("div");
  chartViewport.classList.add("chart-viewport");
  chartViewport.style.minWidth = "850px";
  chartHolder.appendChild(chartViewport);
  const canvas = document.createElement("canvas");
  canvas.classList.add("chart-canvas");
  chartViewport.appendChild(canvas);
  requestAnimationFrame(() => {
    flowChart(canvas, chart, {
      viewport: chartViewport
    });
  });
  return chartHolder;
}